module.exports = __webpack_public_path__ + "static/media/notice2.ab38ddc4.png";